window.addEventListener("load", () => {
  const swatchList = document.querySelectorAll(".bold_option_swatch");
  swatchList.forEach(swatch => {
    const boldOptionTitle = swatch.querySelector(".bold_option_title");
    const selectedSwatch = swatch.querySelector(".bold_swatch_selected input[type='checkbox']");
    if (selectedSwatch) {
      boldOptionTitle.textContent = `${sliceUntilColon(boldOptionTitle.textContent)}: ${selectedSwatch.value}`;
    }

    const checkboxList = swatch.querySelectorAll(".bold_option_value input[type='checkbox']");
    checkboxList.forEach(checkbox => {
      checkbox.addEventListener("change", event => {
        if (event.target.checked) {
          boldOptionTitle.textContent = `${sliceUntilColon(boldOptionTitle.textContent)}: ${event.target.value}`;
        } else {
          boldOptionTitle.textContent = sliceUntilColon(boldOptionTitle.textContent);
        }
      });
    });
  });
  setTimeout(formatPrice,1500);
});

function sliceUntilColon(input) {
    const index = input.indexOf(':');
    return index !== -1 ? input.slice(0, index) : input;
}

function formatPrice(){
    document.querySelectorAll('.bold_option_swatch_title').forEach((el)=>{
        const price = el.querySelector('.bold_option_value_price');
        if (price){
            const swatchTitle = el.querySelector('.bold_option_value_title');
            swatchTitle.childNodes[1].textContent += ` (${price.textContent})`;
            price.remove();
        }
    })
}